var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveShareMixEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106.09 106.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#42a3cd;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_18",
    "data-name": "Layer 18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 106.09,
    height: 106.09,
    rx: 53.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.2,57.92,81.09,34.05a3.18,3.18,0,0,0-2-.76H27.35a3.13,3.13,0,0,0-2,.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.45,70.86a5,5,0,0,0,.11-1V37.81L65.86,52.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63,54.56,53.2,62.94l-9.79-8.38-17,19.2a3,3,0,0,0,.9.16h51.7a3,3,0,0,0,.91-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.54,52.1,23.85,37.81V69.9a4.35,4.35,0,0,0,.11,1Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveShareMixEmailIcon);
export default __webpack_public_path__ + "static/media/SaveShareMixEmailIcon.f704aa40481e5d89a42f0002d62f36eb.svg";
export { ForwardRef as ReactComponent };